import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-page-header',
  standalone: true,
  templateUrl: './mobile-page-header.component.html',
  styleUrl: './mobile-page-header.component.scss',
})
export class MobilePageHeaderComponent {
  @Input() title = '';
  @Input() backLabel = 'Back';
  @Input() showBack = true;
  @Input() fixed = false;
  @Output() back = new EventEmitter<void>();
}
